import React, { useMemo } from "react";
import { Box } from "@tiny/components";
import { PredefinedSegmentsProvider } from "./PredefinedSegments.context";
import { SegmentsSectionProps } from "./PredefinedSegments.types";
import { SectionHeader } from "./SectionHeader";
import { SegmentCards } from "./SegmentCards";

export function RecommendedSegmentsSection({
  segments,
  selected,
  selectionDisabled,
  onSegmentSelect,
}: SegmentsSectionProps) {
  const context = useMemo(
    () => ({
      isDisabled: false,
      isRecommended: true,
    }),
    []
  );

  return (
    <PredefinedSegmentsProvider value={context}>
      <Box id="recommendedSegmentsSection" mt={{ xs: 7, md: 6 }}>
        <SectionHeader
          id="recommendedSegmentsSection_Header"
          title="Recommended Segments"
          subtitle="These pre-defined segments are included in your plan."
        />
        <SegmentCards
          id="recommendedSegmentsSection_Content"
          cards={segments}
          selected={selected}
          onSegmentSelect={onSegmentSelect}
          selectionDisabled={selectionDisabled}
        />
      </Box>
    </PredefinedSegmentsProvider>
  );
}
